var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6353 0.28125L16.2892 3.41825C15.0192 2.99025 13.6033 2.71925 12.0463 2.71925C4.47725 2.71925 0.03125 9.27025 0.03125 9.27025C0.03125 9.27025 1.95925 12.2212 5.17725 14.4082L2.26625 17.3172L3.68025 18.7312L21.0502 1.69625L19.6353 0.28125ZM13.6193 6.06025C10.3313 4.60725 6.93825 7.96825 8.35425 11.2662L6.62825 12.9732C4.81425 11.8132 3.40325 10.3232 2.56825 9.31325C4.06125 7.66525 7.38525 4.71925 12.0463 4.71925C12.9733 4.71925 13.8422 4.83825 14.6562 5.03425L13.6193 6.06025ZM10.7362 13.4913L15.8263 8.49825C16.8433 11.6093 13.8232 14.5653 10.7362 13.4913ZM24.0312 9.27025C24.0312 9.27025 19.7793 16.7192 12.0463 16.7192C10.6673 16.7192 9.38425 16.4282 8.19525 15.9823L9.80925 14.3993C10.5243 14.5922 11.2673 14.7192 12.0463 14.7192C16.8372 14.7192 20.1502 11.1922 21.5502 9.35525C20.8212 8.53325 19.5942 7.36525 17.9632 6.40325L19.4522 4.94325C22.4342 6.84325 24.0312 9.27025 24.0312 9.27025Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.cd4328cf2c837e10e7040e587dba02a5.svg";
export { ForwardRef as ReactComponent };